import { render } from "./DeleteAgent.vue?vue&type=template&id=35e5f5d3"
import script from "./DeleteAgent.vue?vue&type=script&lang=js"
export * from "./DeleteAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__